import { useEffect } from "react";
import { useAttribution } from "./attribution.js";
import { useLeafletContext } from "./context.js";
import { useEventHandlers } from "./events.js";
import { withPane } from "./pane.js";
export function useLayerLifecycle(element, context) {
    useEffect(function addLayer() {
        var _context_layerContainer;
        var container = (_context_layerContainer = context.layerContainer) !== null && _context_layerContainer !== void 0 ? _context_layerContainer : context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            var _context_layerContainer;
            (_context_layerContainer = context.layerContainer) === null || _context_layerContainer === void 0 ? void 0 : _context_layerContainer.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
export function createLayerHook(useElement) {
    return function useLayer(props) {
        var context = useLeafletContext();
        var elementRef = useElement(withPane(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        return elementRef;
    };
}
